import React, { useEffect, useState } from "react";
import AppManager from "../../../managers/AppManager";
import ReadWatchComponent from "../../common/ReadWatchComponent";
import {
  showLoader,
  removeLoader,
  showAlert,
  showToast,
  TOAST_TYPE,
  DKButton,
} from "deskera-ui-library";
import FormatCurrency from "../../../SharedComponents/FormatCurrency";
import { useDispatch, useSelector } from "react-redux";
import PayrollService from "../../../services/PayrollService";
import {
  fetchContractorPayrun,
  selectContractorPayroll,
  fetchContractors,
  selectContractors,
} from "../../../Redux/Slices/ContractorPayrollSlice";
import Utility, { deepClone } from "../../../utility/Utility";
import RouteManager, { PAGE_ROUTES } from "../../../managers/RouteManager";
import TenantManager from "../../../managers/TenantManager";
import { TableManger, TABLES, TABLE_DISPLAY_NAME } from "../../../managers/TableManger";
import {
  parseVisibleColumnConfig,
  contractorPayrollColumnConfig,
  parseColumnConfigContractorPayrun,
} from "../../configs/config";
import DataGridHolderPayroll from "../../common/DataGridHolderPayroll";
import Table from "../../../services/table";
import Popup from "../../common/Popup";
import AddContractorPayrun, { showUpdateContractorPayrollPopup } from "./AddContractorPayrun";
import { PayrollManager } from "../../../managers/PayrollManager";
import { supportedFileTypes } from "../../import_export/EximConstants";
import { getExportDataFile } from "../../import_export/utility/ExportData";
import { TENANT, TenantService } from "../../../managers/TenantManagerService";
import GiroService from "../../../services/GiroService";
import PermissionUtils, { ACTION, MODULE } from "../../user-permissions/PermissionUtils";

const ContractorPayrunList = (props) => {

    const initialState = {
      columnData: [],
      rowData: [],
      originalData: [],
      filter: [],
    };

    const deleteConfirm = (data) => [
      {
        title: "Cancel",
        className: "bg-gray1 border-m",
        onClick: () => loadContractorPayrolls(PayrollService.config)
      },
      {
        title: "Delete",
        className: "bg-red text-white ml-r",
        onClick: () => deleteRecord(data),
      },
    ];

    const cannotDeleteOrUpdate = [
      {
        title: "Cancel",
        className: "bg-gray1 border-m",
      },
    ];
    var selectedRow = []
    //React hooks
    const [recentUpcoming, setRecentUpcoming] = useState([]);
    const [contractorPayrolls, setContractorPayrolls] = useState(initialState);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPageCount, setTotalPageCount] = useState(1);
    const [totalCount, setTotalCount] = useState(10);

    const [showPayrunPopup, setPopup] = useState(false)
    const [reload, setReload] = useState(false);
    const [exportButtonName, setExportButtonName] = useState('Export Payrun')
    //Store
    const dispatch = useDispatch();
    const contractorPayrollData = useSelector(selectContractorPayroll);
    const contractors = useSelector(selectContractors);

    useEffect(() => {
        RouteManager.setPresenter({ props });
        showLoader();
        /* API Calls Start */
        loadContractorPayrolls({});

        return () => setContractorPayrolls(initialState);
    },[]);

    useEffect(() => {
      if (!Utility.isEmpty(contractorPayrollData)) {
          const loadUsers = loadUsersList();
          const filterResponse = contractorPayrollData.filterResponse;
          const payruns = contractorPayrollData.payruns || [];
          const { tenant } = TenantManager.getPeopleTenantData();
          const isCashfreeEnabled =
            tenant && tenant.isCashfreeEnabled
              ? tenant.isCashfreeEnabled
              : false;
          const functionConfig = getFunctionConfig();
          // const functionConfig = [];
          const rowData = contractorPayrollColumnConfig(payruns, isCashfreeEnabled, functionConfig, MODULE.CONTRACTOR_PAYRUN);
          let columns = parseColumnConfigContractorPayrun(deepClone(TableManger.getTableColumns(TABLES.PAYROLL)));
          let payrollColumn = parseVisibleColumnConfig(columns);
          const passingData = {
            columnData: deepClone(payrollColumn),
            rowData,
            filter: [],
            originalData: payruns,
          };
          removeLoader();
          setContractorPayrolls(passingData);
          setTotalPageCount(filterResponse.totalPages);
          setCurrentPage(+filterResponse?.currentPage);
          setTotalCount(filterResponse.totalCount);
          getRecentUpcomingPayroll(payruns);
      }
    }, [contractorPayrollData, reload]);

    const loadUsersList = async (config) => {
      try {
        // PayrollService.apiConfig = config;
        await dispatch(fetchContractors());
      } catch (err) {
        console.error("Error loading workweeks: ", err);
      }
    };

    const getFunctionConfig = () => {
      let config = {
        "editPayroll": onRowEdit,
        "deletePayroll": onDeletePayroll,
        "processPayroll": processPayroll,
        "viewPayroll": viewDetailedView,
        "makePayment": onMakePayment
      };
      return config;
    };

    const getRecentUpcomingPayroll = (payruns) => {
      let inputPayrolls = payruns.filter((x) => !x.processed);
      const sortByDate = (arr) => {
        const sorter = (a, b) => {
          return (
            new Date(b.processedAt).getTime() -
            new Date(a.processedAt).getTime()
          );
        };
        arr.sort(sorter);
      };
      sortByDate(inputPayrolls);
      setRecentUpcoming(inputPayrolls);
    };

    const loadContractorPayrolls = async (config) => {
      try {
        PayrollService.apiConfig = {
          Limit: 20,
          CurrentPage: 1,
          Order: "desc",
          Field: "_id",
          SearchString: true,
          SearchField: `isForContractors`,
        };
        await dispatch(fetchContractorPayrun());
      } catch (err) {
        console.error("Error loading payrolls: ", err);
      }
    };

    const navigateToProcessPayroll = (data, isFromGrid) => {
    //   let payrollId = "";
    //   if (!isFromGrid) {
    //     payrollId = recentUpcoming[0]._id;
    //   }
    //   RouteManager.navigateToPage(
    //     PAGE_ROUTES.PROCESS_PAYROLL,
    //     `module=${TABLES.PAYROLL}&origin=${PAGE_ROUTES.PAYROLL_GRID}&id=${payrollId}&step=0`
    //   );
    };

    const onRowEdit = (data, isFromRowOpen) => {
      const rowData = data && data.rowData ? data.rowData : "";
      if (!isFromRowOpen && rowData) {
        if (!rowData.processed) {
          const payrollId = data.rowData ? data.rowData.id : "";
          const { payruns, filterResponse } = contractorPayrollData;
          const selectedPayrun = payruns.filter((x) => x._id === payrollId);
          if (selectedPayrun && selectedPayrun.length > 0) {
            let dataToEdit = selectedPayrun[0];
            // PayrollManager.getPayrollDefaultValues(dataToEdit);
            let usersList = contractors ? contractors.users : [];
            showUpdateContractorPayrollPopup({
              tableName: "people_add_payroll",
              displayName: "Payrun",
              recordId: payrollId,
              defaultValues: dataToEdit,
              isCustomForm: true,
              inputData: {
                users: usersList,
                payrollDispatch: dispatch,
              },
            });
          }
        } else {
          showAlert(
            "Sorry!!",
            "Processed payroll cannot be edited",
            cannotDeleteOrUpdate
          );
        }
      } else if (isFromRowOpen && rowData) {
        if (rowData.processed) {
          viewDetailedView({ rowData: rowData });
        } else {
          processPayroll({ rowData: rowData });
        }
      }
    };

    const onDeletePayroll = (data) => {
      const rowData = data && data.rowData ? data.rowData : '';
      if(rowData && typeof data == 'object') {
          if(!rowData.processed) {
              showAlert(
                  "Delete Record?",
                  "Deleting this record will delete it permanently you will not be able to restore it.",
                  deleteConfirm([rowData])
              )
          } else {

          }
      } else {
        let isProcessed = false;
        data.forEach(row=>{
          if(row.processed){
            isProcessed = true;
          }
        })
        if(isProcessed) {
            showAlert(
                "Sorry!!",
                "Processed payroll cannot be deleted",
                cannotDeleteOrUpdate
            )
            loadContractorPayrolls(PayrollService.config);
            return;
        } else {
          showAlert(
            "Delete Record?",
            "Deleting this record will delete it permanently you will not be able to restore it.",
            deleteConfirm(data)
        )
        }

      }
      // ContactService.deleteContact(payrollId).then((res) => {
      //     showToast('Contact Deleted Successfully', TOAST_TYPE.WARNING);
      //     loadContacts({});
      // });
  };

    const viewDetailedView = (data) => {
      const rowData = data && data.rowData ? data.rowData : "";
      if (rowData) {
        if (rowData.processed) {
          let payrunId = rowData.id;
          if (payrunId) {
            RouteManager.navigateToPage(
              PAGE_ROUTES.PROCESS_SUMMARY,
              `id=${payrunId}&isContractor=true`
            );
          }
        } else {
          showAlert(
            "Sorry!!",
            "Summary can only be viewed of Processed payrolls.",
            cannotDeleteOrUpdate
          );
        }
      }
    };

    const processPayroll = (data) => {
      const rowData = data && data.rowData ? data.rowData : "";
      if (rowData) {
        if (!rowData.processed) {
          let payrunId = rowData.id;
          if (payrunId) {
            RouteManager.navigateToPage(
              // PAGE_ROUTES.CONTRACTOR_PAYRUN_LIST
              PAGE_ROUTES.PROCESS_PAYROLL,
              `module=${TABLES.PAYROLL}&origin=${PAGE_ROUTES.CONTRACTOR_PAYRUN_LIST}&id=${payrunId}&step=0&isContractor=true`
            );
          }
        } else {
          showAlert(
            "Sorry!!",
            "Selected Payroll has already been processed.",
            cannotDeleteOrUpdate
          );
        }
      }
    };

    const onCreateNew = (row = {}) => {
      console.log("Hey");
      setPopup(true)

      // let paySchedules = payscheduleList ? payscheduleList.schedules : [];
      let usersList = contractors ? contractors.users : [];
      // let usersList = [];
      // let tenant = tenantData && tenantData.tenant ? tenantData.tenant : {};
      showUpdateContractorPayrollPopup({
        tableName: "people_add_payroll",
        displayName: "Payrun",
        recordId: row ? row.id : "",
        defaultValues: PayrollManager.getDefaultValues(),
        isCustomForm: true,
        inputData: {
          users: usersList,
          payrollDispatch: dispatch,
        },
      });
    };

    const deleteRecord = (data) => {
      let params = []
        data.forEach(row=>{
          params.push({
            payrunId:row.id
          })
        })
      Table.deletePayroll(params).then((data) => {
        showToast("Record Deleted Successfully", TOAST_TYPE.SUCCESS);
        loadContractorPayrolls(PayrollService.config);
      });
    };

    const onSearch = (searchTerm) => {
      const config = {
        ...PayrollService.apiConfig,
        Page: 0,
        SearchTerm: searchTerm,
      };
      loadContractorPayrolls(config);
    };
    const newColumnAdded = (data) => {
      const columns = contractorPayrolls.columnData;
      columns.push(data);
      setContractorPayrolls({ ...contractorPayrolls, columnData: columns });
    };

    const onFilter = (updatedList, queries) => {
      // if (queries.length === 0) {
      //     setContacts({
      //         ...contacts,
      //         rowData: contacts.originalData,
      //         filter: queries
      //     });
      // } else {
      //     setContacts({
      //         ...contacts,
      //         rowData: updatedList,
      //         filter: queries
      //     });
      // }
    };

    const onContextCancel = () => {
      setReload(!reload)
    }
    const cannotExport = [
      {
        title: "Cancel",
        className: "bg-gray1 border-m",
      }
    ];
    const exportPayrun = (data) => {

      const queryParams = {
        format: 'XLSX',
        countryCode: TenantService.get(TENANT.COUNTRY_CODE),
        timezoneOffset: new Date().getTimezoneOffset() * -1,
        isContractor:true
      };
      const options = {
        endPointOptions: null,
        fileName: 'Payrun',
        fileType: supportedFileTypes['XLSX']
      }
      setExportButtonName('Exporting...')
      getExportDataFile(queryParams, data, options, 'EXPORT_PAYRUN')
        .then((res) => {
          setExportButtonName('Export Payrun')
          showToast('Payrun exported Successfully', TOAST_TYPE.SUCCESS);
          setReload(!reload);
        })
        .catch((error) => {
          setExportButtonName('Export Payroll')
          showToast('Internal server error', TOAST_TYPE.ERROR);
          setReload(!reload);
        });
    }

    const onMakePayment = (data) => {
        if (data.rowData.payrollData) {
            let payrun = data.rowData.payrollData
            GiroService.MakePaymentValues = {
                payrunId: payrun._id,
                totalCost: payrun.netPay || 0,
                firstPayDate: payrun.payDate,
                backRout: PAGE_ROUTES.CONTRACTOR_PAYRUN_LIST
            }
            RouteManager.navigateToPage(PAGE_ROUTES.GIRO_MAKE_PAYMENT + '/1');
        }
    }

    return (
      <>
        <ReadWatchComponent
          title="Need help getting started? Learn more about creating Contractor Payroll."
          onRead={() =>
            window.open(
              "https://www.deskera.com/care/add-new-payrun-deskera-hris/",
              "_blank"
            )
          }
          onWatch={AppManager.showComingSoonWarning}
          export={PermissionUtils.hasAccess(MODULE.CONTRACTOR_PAYRUN, ACTION.EXPORT) && PermissionUtils.hasAccess(MODULE.SALARY, ACTION.VIEW) ? exportButtonName : null}
          exportTitle='Manage your Payroll.'

          exportTitleInfo=""
          onExportClick={() => {
            if (selectedRow.length == 0) {
              showAlert("Info", "Please select payrun(s) to export.", cannotExport)
            } else {
              let payrollIdsToExport = []
              selectedRow.forEach(row => {
                payrollIdsToExport.push(row.id)
              })
              let payload = {
                ids: payrollIdsToExport,
              };
              exportPayrun(payload);
            }

          }
          }
        />
        {recentUpcoming && recentUpcoming.length ? (
          <div className="parent-width">
            <div className="bg-white p-l mt-l border-radius-m border-m margin-empty-mobile">
              <div className="row">
                {/* <div className="column"> */}
                {/* <div className="row">
                    <span className="text-gray">Upcoming Payroll</span>
                    <span className="ml-s fw-m">
                      {recentUpcoming[0] && recentUpcoming[0]["paySchedule"]
                        ? recentUpcoming[0]["paySchedule"]["name"]
                        : ""}
                    </span>
                  </div> */}
                {/* <div className="text-gray mt-s fs-m">
                    {recentUpcoming[0]
                      ? Utility.formatDate(
                          recentUpcoming[0]["payDate"],
                          FORMAT.MMDDYYYY_2
                        )
                      : ""}
                  </div> */}
                {/* </div> */}
                <div
                  className="ms-auto"
                  style={{
                    marginLeft: "auto",
                  }}
                >
                  {/* <DKButton
                    className="bg-app text-white"
                    style={{
                      "justify-content": "center",
                    }}
                    title="Process Payroll"
                    onClick={(data) => navigateToProcessPayroll(data, false)}
                  /> */}
                </div>
              </div>
              <div className="row mt-xxl">
                <div className="column mr-xxl pr-xl">
                  <span className="fw-m fs-xl">
                    <FormatCurrency
                      className="fw-m fs-xl"
                      amount={recentUpcoming[0].totalCost}
                    />
                  </span>
                  <span className="text-gray">Total Contractor Cost</span>
                </div>
                <div className="column">
                  <span className="fw-m fs-xl">
                    {Utility.formatDate(
                      recentUpcoming[0].payDate,
                      "MM/DD/YYYY",
                      ""
                    )}
                  </span>
                  <span className="text-gray">Pay Day</span>
                </div>
                {/* <div className="column mr-xxl pr-xl">
                  <span className="text-gray">Total Deductions</span>
                  <span className="fw-m fs-xl">
                    <FormatCurrency
                      className="fw-m fs-xl"
                      amount={
                        recentUpcoming[0].totalCost -
                        recentUpcoming[0].totalEarnings
                      }
                    />
                  </span>
                </div> */}
              </div>
            </div>
          </div>
        ) : null}
        <div className="column parent-width flex-1">
          {/* {true && (
            <SegmentListContainer
              data={payrollFilters}
              selectedId={initialValue}
              onChange={onSegmentSelect}
              // onClickNew={this.showAddSegmentPopup}
              maxWidth={React.createRef().current?.innerWidth}
              isAddEnabled={false}
            />
          )} */}
          <div className="column mt-l parent-width mb-s position-relative flex-1 margin-empty-mobile">
            <DataGridHolderPayroll
              tableName={TABLES.PAYROLL}
              displayTableName={TABLE_DISPLAY_NAME[TABLES.CONTRACTOR_PAYROLL]}
              allowRowEdit={PermissionUtils.hasAccess(MODULE.CONTRACTOR_PAYRUN,[ACTION.SUBMIT])}
              allowColumnEdit={false}
              allowRowAdd={true}
              allowColumnAdd={false}
              allowColumnDelete={true}
              allowColumnShift={false}
              allowSearch={false}
              allowFilter={false}
              onRowDelete={(data)=>{
                onDeletePayroll(data)
              }}
              onRowEdit={(data, isFromRowOpen) => {
                onRowEdit(data, isFromRowOpen);
              }}
              onCancelContext={() => {
                onContextCancel();
              }}
              onRowDetailedView={viewDetailedView}
              onProcessPayroll={processPayroll}
              // refresh={refresh}
              addButtonConfig={[
                {
                  title: "+ Pay Contractor",
                  className: "bg-app text-white",
                  onClick: () => onCreateNew(),
                },
              ]}
              allowDataExport={true}
              gridData={contractorPayrolls}
              onSearch={onSearch}
              onColumnAdd={newColumnAdded}
              onFilter={onFilter}
              filter={contractorPayrolls.filter}
              // onRowAdd={onRowAdd}
              onSelection={(data) => {
                selectedRow = data;
              }}
              onPaginationClick={(requestedPageNumber) => {
                const config = {
                  ...PayrollService.apiConfig,
                  CurrentPage: requestedPageNumber, // Books backend pagination offset is 0, so subtract 1
                  Limit: 20,
                  Order: "desc",
                  Field: "_id",
                  SearchString: true,
                  SearchField: `isForContractors`,
                };
                loadContractorPayrolls(config);
              }}
              currentPage={currentPage}
              totalPageCount={totalPageCount}
              isActionEnabled={true}
              contextMenu={true}
              showContextEdit={false}
              isMenuVisible={true}
              onColumnShift={(data)=> setReload(!reload)}
              module={MODULE.CONTRACTOR_PAYRUN}
            />
          </div>
          {/* {showPayrunPopup && (
            <AddContractorPayrun onClose={setPopup(false)}></AddContractorPayrun>
            // showPayrollPopup()
          )} */}
        </div>
      </>
    );
}

export default ContractorPayrunList;
